import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import {
  Box,
  HStack,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

const PLAYER_COUNT = 3;

export const EventSignupSummarySkeleton = () => {
  return (
    <VStack gap={6} padding={5} testID="event-signup-summary-skeleton">
      {/* Header skeleton */}
      <HStack justifyContent="space-between" alignItems="center">
        <SkeletonLoader height={40} width={40} borderRadius="1" />
        <VStack alignItems="center" gap={1}>
          <SkeletonLoader height={12} width={100} borderRadius="1" />
          <SkeletonLoader height={16} width={160} borderRadius="1" />
        </VStack>
        <SkeletonLoader height={56} width={56} borderRadius="1" />
      </HStack>

      {/* Players section skeleton */}
      <VStack gap={3}>
        <SkeletonLoader height={20} width={80} borderRadius="1" />
        {Array.from({ length: PLAYER_COUNT }).map((_, idx) => (
          <HStack key={`player-${idx}`} gap={3} alignItems="center">
            <SkeletonLoader height={32} width={32} borderRadius="6" />
            <VStack flex={1} gap={1}>
              <SkeletonLoader height={16} width={140} borderRadius="1" />
              <SkeletonLoader height={12} width={100} borderRadius="1" />
            </VStack>
          </HStack>
        ))}
      </VStack>

      {/* Form answers skeleton */}
      <VStack gap={3}>
        <SkeletonLoader height={20} width={120} borderRadius="1" />
        <Box
          padding={4}
          borderWidth={1}
          borderColor="grayscale-200"
          borderRadius="2"
        >
          <SkeletonLoader height={16} width={140} borderRadius="1" />
          <Box marginTop={2}>
            <SkeletonLoader height={12} width="100%" borderRadius="1" />
          </Box>
          <Box marginTop={2}>
            <SkeletonLoader height={12} width="80%" borderRadius="1" />
          </Box>
        </Box>
      </VStack>

      {/* Total skeleton */}
      <VStack gap={3}>
        <SkeletonLoader height={20} width={150} borderRadius="1" />
        <SkeletonLoader height={80} width="100%" borderRadius="1" />
      </VStack>

      {/* Button skeleton */}
      <SkeletonLoader height={48} width="100%" borderRadius="1" />
    </VStack>
  );
};
